/* tslint:disable */
/* eslint-disable */
export enum WorkDebtorInvoiceTypeEnum {
  Teilrechnung = 'TEILRECHNUNG',
  Zwischenrechnung = 'ZWISCHENRECHNUNG',
  Akontorechnung = 'AKONTORECHNUNG',
  Gesamtrechnung = 'GESAMTRECHNUNG',
  Schlussrechnung = 'SCHLUSSRECHNUNG',
  Nachrechnung = 'NACHRECHNUNG'
}
